var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsField',{staticClass:"details-amount",attrs:{"name":_vm.name,"value":`${_vm.prefixedAmount(_vm.amount)} AE`,"value-monospace":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }